/*Created by chenyanhua at 2017/6/6 */
import React, { Component,PropTypes } from "react";
import "./style/style.css";

class JcBreadCrumb extends Component {
    constructor(props) {
        super(props);
        debugger;
        this.state = {
            menu: props.menu || []
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.menu){
            this.setState({
                menu: nextProps.menu || []
            });
        }
    }

    render() {
        return (
            <div className='jc-breadcurmb' key="jc-breadcurmb" >
               { this.renderBreadCrumb() }
            </div>
        )
    }

    renderBreadCrumb = ()=>{
        let lastIndex = this.state.menu.length-1;
        return this.state.menu.map((item,index)=>{
            if(index==lastIndex){
                return <span key={index}  className='jc-bc-item'>{item.name}</span>;
            }else{
                return  <span key={index} className='jc-bc-item' >
                            <a href={item.url} target='_blank' >{item.name}</a><span className='jc-bc-split'>/</span>
                        </span>;
            }
        });
    }
}

export default JcBreadCrumb;